import { SET_TAB_LAYERS_FILTER, SET_TAB_LAYERS_FILTER_DISABLED } from 'drawer/tabs/layers/search/actions'

export const tabLayersFilter = (state = null, action) => {
  switch (action.type) {
    case SET_TAB_LAYERS_FILTER:
      return action.tabLayersFilter
    default:
      return state
  }
}

export const tabLayersFilterDisabled = (state = null, action) => {
  switch (action.type) {
    case SET_TAB_LAYERS_FILTER_DISABLED:
      return action.tabLayersFilterDisabled
    default:
      return state
  }
}
